"use client";

import clsx from 'clsx'
import {useLanguage} from "@/context/LanguageContext";

const texts = {
  en: {
    company: 'Company',
    venue: 'Venue',
    vatNumber: 'VAT Number',
  },
  it: {
    company: 'Azienda',
    venue: 'Sede',
    vatNumber: 'Partita IVA',
  },
};

function Office({
  name,
  children,
  invert = false,
}: {
  name: string
  children: React.ReactNode
  invert?: boolean
}) {
  return (
    <address
      className={clsx(
        'text-sm not-italic',
        invert ? 'text-neutral-300' : 'text-neutral-600',
      )}
    >
      <strong className={invert ? 'text-white' : 'text-neutral-950'}>
        {name}
      </strong>
      <br />
      {children}
    </address>
  )
}

export function Offices({
  invert = false,
  ...props
}: React.ComponentPropsWithoutRef<'ul'> & { invert?: boolean }) {
  const { language } = useLanguage();
  //console.log(texts[language as keyof typeof texts]?.vatNumber || texts['en'].vatNumber+': 13916720967');
  /*if (typeof window === "undefined") {
    console.log("Server rendering:", "IVA: 13916720967");
  } else {
    console.log("Client rendering:", "IVA: 13916720967");
  }*/
  return (
    <ul role="list" {...props}>
      <li>
        <Office name={texts[language as keyof typeof texts]?.venue || texts['en'].venue} invert={invert}>
          Via Flora 68
          <br />
          20025, Legnano (MI), Italia
          <br />
          PEC: cris.aguilar@pec.it
        </Office>
      </li>
      <li>
        <Office name={texts[language as keyof typeof texts]?.company || texts['en'].company} invert={invert}>
          Cris Aguilar Espinoza
          <br />
          {texts[language as keyof typeof texts]?.vatNumber || texts['en'].vatNumber}{': 13916720967'}
          <br />
          SDI: LARXJI4
        </Office>
      </li>
    </ul>
  )
}
